import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/following/importer/followingImporterActions';

export default importerReducers(actions);
